import { memo } from "react";
import type { BuilderUIProviderProps } from "@circle-react-shared/BuilderUI/Store/types";
import { AttachmentProvider } from "../Media/AttachmentContext";
import { BuilderUIErrorBoundary } from "./BuilderUIErrorBoundary";
import { DragAndDropProvider } from "./DragAndDropProvider";
import { StoreProvider } from "./StoreProvider";

export const Provider = memo(
  ({ children, ...props }: BuilderUIProviderProps) => (
    <BuilderUIErrorBoundary>
      <AttachmentProvider
        attachments={props.inlineAttachments ?? []}
        pages={props.pages}
      >
        <StoreProvider {...props}>
          <DragAndDropProvider>{children}</DragAndDropProvider>
        </StoreProvider>
      </AttachmentProvider>
    </BuilderUIErrorBoundary>
  ),
);

Provider.displayName = "BuilderUIProvider";
